/** Keep HTTP failures and non-array bodies out of list query caches. */
export async function fetchArray<T>(url: string, resource: string): Promise<T[]> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load ${resource} (HTTP ${response.status})`);
  }
  let data: unknown;
  try {
    data = await response.json();
  } catch {
    throw new Error(`Failed to load ${resource} (invalid JSON response)`);
  }
  if (!Array.isArray(data)) {
    throw new Error(`Failed to load ${resource} (unexpected response)`);
  }
  return data as T[];
}
